import type { ListBuilderList } from '../../../types';
import { createShopSuggestedColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_SUGGESTED_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Suggested (Reorder) list configuration
 * Items due for reorder with forecast data
 */
export const shopSuggestedList: ListBuilderList = {
	id: 'shop_suggested',
	cacheTTL: 600000,
	name: 'Reorder',
	type: 'default',
	active: true,
	sortOrder: 1,
	columns: createShopSuggestedColumns(),
	description: 'Reorder items for the client shop',
	defaultSortId: 'column-forecast-asc',
	requiredFields: SHOP_SUGGESTED_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'reorder',
					label: 'Reorder',
				},
			],
		},
	},
};
